import React, { useEffect, useRef, useState } from "react"
import { Editor } from "@tinymce/tinymce-react"

interface Props {
     height: number
     onChange: (val: string) => void
     value?: string
     placeholder: string
     forceEditorToRefreshContent?: { value: string; random: string } | undefined
}

const MyEditorField: React.FC<Props> = ({ height, value, forceEditorToRefreshContent, onChange, placeholder }) => {
     const editorRef = useRef<any>(null)
     const [initialValue, setInitialValue] = useState<string>(value || "")
     // 1. Add loading state
     const [isLoading, setIsLoading] = useState<boolean>(true)

     useEffect(() => {
          // Update the component's state when the prop changes
          if (forceEditorToRefreshContent) setInitialValue(forceEditorToRefreshContent.value)
     }, [forceEditorToRefreshContent])

     return (
          // 2. Wrap in a relative container to position the loader
          <div className="position-relative" style={{ minHeight: height }}>
               {/* 3. The Loader Overlay */}
               {isLoading && (
                    <div
                         className="position-absolute top-0 start-0 w-100 d-flex flex-column align-items-center justify-content-center bg-light rounded"
                         style={{ height: height, zIndex: 10 }}
                    >
                         <div className="spinner-border text-primary" role="status">
                              <span className="visually-hidden">Loading...</span>
                         </div>
                         <div className="text-gray-500 fs-7 fw-bold mt-2">Chargement de l'éditeur...</div>
                    </div>
               )}

               <Editor
                    apiKey="wfpwyzgdaawv07lctznk41hhcpvh1y4r6hqp2p4twhqe3big"
                    onInit={(evt, editor) => {
                         editorRef.current = editor
                         // 4. Turn off loader when ready
                         setIsLoading(false)
                    }}
                    initialValue={initialValue}
                    onEditorChange={onChange}
                    init={{
                         height,
                         menubar: false,
                         branding: false,
                         placeholder: placeholder, // TinyMCE supports placeholder in init
                         plugins: [
                              "advlist",
                              "autolink",
                              "lists",
                              "link",
                              "image",
                              "charmap",
                              "preview",
                              "anchor",
                              "visualblocks",
                              "code",
                              "fullscreen",
                              "insertdatetime",
                              "table",
                         ],
                         toolbar: "blocks bold italic forecolor | alignleft aligncenter alignjustify | bullist numlist | fullscreen",
                         content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                    }}
               />
          </div>
     )
}

export default MyEditorField
